import { IRaidEncounterRosterMemberCharacter } from '../../wowretail/src/shared/types/raidTypes';
import { TSpecSummary } from '../types/utilityTypes';
import { wowGameDataSlugify } from './slugify';
import { TCharacterDungeonLoadoutOption, TCharacterLoadoutOption } from '../types/characterTypes';

export const getLoadoutOptionKey = (activityType: string, loadoutId: number) => `${activityType}__${loadoutId}`;

export const isDungeonLoadoutOption = (option: TCharacterLoadoutOption): option is TCharacterDungeonLoadoutOption =>
  'mythic_level' in option;

export const parseLoadoutOptionKey = (key: string) => {
  const [activityType, loadoutId] = key.split('__');
  return { activityType, loadoutId: Number(loadoutId) };
};

const CHARACTER_REGION_ARMORY_INFO: any = {
  us: {
    url: 'https://worldofwarcraft.com/{locale}/character/{region}/{realm}/{characterName}',
    locale: 'en-us'
  },
  eu: {
    url: 'https://worldofwarcraft.com/{locale}/character/{region}/{realm}/{characterName}',
    locale: 'en-gb'
  },
  kr: {
    url: 'https://worldofwarcraft.com/{locale}/character/{region}/{realm}/{characterName}',
    locale: 'ko-kr'
  },
  tw: {
    url: 'https://worldofwarcraft.com/{locale}/character/{region}/{realm}/{characterName}',
    locale: 'zh-tw'
  },
  cn: {
    url: 'https://wow.blizzard.cn/character/#/{realm}/{characterName}',
    locale: 'zh-cn'
  }
};

export const GUILD_REGION_ARMORY_INFO: any = {
  us: {
    domain: 'worldofwarcraft.com',
    locale: 'en-us'
  },
  eu: {
    domain: 'worldofwarcraft.com',
    locale: 'en-gb'
  },
  kr: {
    domain: 'worldofwarcraft.com',
    locale: 'ko-kr'
  },
  tw: {
    domain: 'worldofwarcraft.com',
    locale: 'zh-tw'
  },
  cn: {
    domain: 'www.wowchina.com',
    locale: 'zh-cn'
  }
};

// live on worldofwarcraft.com site now
export function buildCharacterArmoryUrl(regionSlug: string, realmSlug: string, characterName: string) {
  const info = CHARACTER_REGION_ARMORY_INFO[regionSlug] || CHARACTER_REGION_ARMORY_INFO.us;

  return info.url
    .replace('{locale}', info.locale)
    .replace('{region}', regionSlug)
    .replace('{realm}', encodeURIComponent(wowGameDataSlugify(realmSlug)))
    .replace('{characterName}', characterName);
}

function getSortOrdinalForSpec(spec: TSpecSummary): number {
  switch (spec.role) {
    case 'dps':
      return spec.is_melee ? 3 : 4;
    case 'healer':
      return 2;
    case 'tank':
      return 1;
    default:
      return 999;
  }
}

export const sortCharactersRoster = (
  a: IRaidEncounterRosterMemberCharacter,
  b: IRaidEncounterRosterMemberCharacter
) => {
  const aRoleOrder = getSortOrdinalForSpec(a.spec);
  const bRoleOrder = getSortOrdinalForSpec(b.spec);

  if (aRoleOrder === bRoleOrder) {
    if (a.class.slug === b.class.slug) {
      if (a.spec.slug === b.spec.slug) {
        if (b.name === a.name) {
          return 0;
        } else if (a.name < b.name) {
          return -1;
        } else {
          return 1;
        }
      } else {
        if (a.spec.slug < b.spec.slug) {
          return -1;
        } else {
          return 1;
        }
      }
    } else {
      if (a.class.slug < b.class.slug) {
        return -1;
      } else {
        return 1;
      }
    }
  } else {
    return aRoleOrder - bRoleOrder;
  }
};

export enum CharacterFlags {
  REMIX = 1
}

export enum CharacterLoadoutHistoryPrivacy {
  SHOW_ALL = 'show-all',
  SHOW_X_MOST_RECENT = 'show-most-recent',
  SHOW_LATEST_ONLY = 'show-latest'
}
